/* eslint-disable */
import React, { Component } from 'react';
import { compose } from 'recompose';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import {
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow,
} from 'react-google-maps';
import Loader from '../../common/LoadingSpinner';
import * as api from '../../../epics/api';

import history from '../../../history';
import {getRelevantJobId} from "../../../utils";

const googleMapsURL =
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyDqHBEWoYWwCSk_GUKhIcg06jbpgaUZRe4&v=3.exp' +
    '&libraries=geometry,drawing,places';

const ClockInOutMapComponent = compose(withGoogleMap)(props => {
    let freelancerClockinLocation;
    let freelancerClockOutLocation;
    const jobLocationmarker = (
        <Marker
            position={{
                lat: props.job.latitude,
                lng: props.job.longitude,
            }}
            key={props.job.booking.id}
            style={{ height: '5xpx', width: '5px' }}
            className="marker"
        >
            <InfoWindow>
                <div>
                    <p className="font-bold-800">Job location</p>
                </div>
            </InfoWindow>
        </Marker>
    );

    if (props.clockin && props.clockin.location) {
        freelancerClockinLocation = (
            <Marker
                position={{
                    lat: props.clockin.location.latitude,
                    lng: props.clockin.location.longitude,
                }}
                key={props.clockin.id}
                style={{ height: '5xpx', width: '5px' }}
                className="marker"
            >
                <InfoWindow>
                    <div>
                        <p>
                            Clock-in at{' '}
                            {moment(props.clockin.clocking_time).format(
                                'HH:mm',
                            )}
                        </p>
                    </div>
                </InfoWindow>
            </Marker>
        );
    }

    if (props.clockout && props.clockout.location) {
        freelancerClockOutLocation = (
            <Marker
                position={{
                    lat: props.clockout.location.latitude,
                    lng: props.clockout.location.longitude,
                }}
                key={props.clockout.id}
                style={{ height: '5xpx', width: '5px' }}
                className="marker"
            >
                <InfoWindow>
                    <div>
                        <p>
                            Clock-out at{' '}
                            {moment(props.clockout.clocking_time).format(
                                'HH:mm',
                            )}
                        </p>
                    </div>
                </InfoWindow>
            </Marker>
        );
    }

    return (
        <GoogleMap
            defaultZoom={13}
            defaultCenter={{
                lat: props.job.latitude,
                lng: props.job.longitude,
            }}
            defaultOptions={{
                disableDefaultUI: true,
                zoomControl: true,
                styles: [
                    {
                        featureType: 'all',
                        stylers: [{ saturation: '-75' }],
                    },
                    {
                        featureType: 'poi',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: 'administrative.locality',
                        stylers: [{ visibility: 'off' }],
                    },
                    {
                        featureType: 'water',
                        stylers: [
                            { hue: '0' },
                            { saturation: '40' },
                            { lightness: '-10' },
                        ],
                    },
                ],
            }}
            ref={props.onMapMounted}
        >
            {jobLocationmarker}
            {freelancerClockinLocation}
            {freelancerClockOutLocation}
        </GoogleMap>
    );
});

class ConflictTimesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clockin: this.props.job.booking
                ? this.props.job.booking.clock_in
                : null,
            clockout: this.props.job.booking
                ? this.props.job.booking.clock_out
                : null,
            adminClockInTime: moment(this.props.job.start_datetime),
            adminClockOutTime: moment(this.props.job.end_datetime),
            passedClockOutTime:
                moment() > moment(this.props.job.end_datetime).add(3, 'hours'),
            isPosting: false,
        };

        this.handleAdminClockInDateTimeChange =
            this.handleAdminClockInDateTimeChange.bind(this);
        this.handleAdminClockOutDateTimeChange =
            this.handleAdminClockOutDateTimeChange.bind(this);
        this.updateClockInOutTimes = this.updateClockInOutTimes.bind(this);
        this.getConflictReasonText = this.getConflictReasonText.bind(this);
        this.clockInOutUpdated = this.clockInOutUpdated.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onMapMounted = this.onMapMounted.bind(this);
    }

    onMapMounted = ref => {
        // eslint-disable-next-line no-undef
        const bounds = new google.maps.LatLngBounds();
        if (this.props.job) {
            bounds.extend({
                lat: this.props.job.latitude,
                lng: this.props.job.longitude,
            });
        }
        let rezoom = false;
        if (this.state.clockin && this.state.clockin.location) {
            bounds.extend({
                lat: this.state.clockin.location.latitude,
                lng: this.state.clockin.location.longitude,
            });
            rezoom = true;
        }
        if (this.state.clockout && this.state.clockout.location) {
            bounds.extend({
                lat: this.state.clockout.location.latitude,
                lng: this.state.clockout.location.longitude,
            });
            rezoom = true;
        }
        if (rezoom && ref) {
            ref.fitBounds(bounds, { top: 150, bottom: 10, right: 50, left: 0 });
        }
    };

    closeModal(refereshTable = false) {
        const { id } = this.props.job.booking;
        const pathname = this.props.location.pathname.replace(
            `clockin-out/${id}`,
            '',
        );
        history.push(pathname + this.props.location.search);
        if (refereshTable) {
            setTimeout(() => {
                this.props.table.table.fireFetchData();
            }, 100);
        }
    }

    handleAdminClockInDateTimeChange(date) {
        this.setState({
            adminClockInTime: moment(date),
        });
    }

    handleAdminClockOutDateTimeChange(date) {
        this.setState({
            adminClockOutTime: moment(date),
        });
    }

    postTime(data) {
        this.setState({ isPosting: true });
        const relevantJobId = getRelevantJobId(this.props.job);
        return api.executeHttpRequest(
            `jobs/${relevantJobId}/clock-in/`,
            'post',
            data,
        );
    }

    clockInOutUpdated(message, success = true) {
        this.setState({ isPosting: false });
        if (success) {
            this.props.notification.success('Success', message);
            this.closeModal(true);
        } else {
            this.props.notification.error('Error', message);
            this.closeModal();
        }
        if (this.props.mode === 'payroll') {
            this.props.reloadData();
        }
    }

    updateClockInOutTimes() {
        const self = this;
        const postDate = {
            freelancer: this.props.job.booking.freelancer_detail.id,
            force: true,
        };
        const clockInPostData = {
            ...postDate,
            category: 'CI',
            clocking_time: this.state.adminClockInTime.format(
                'YYYY-MM-DDTHH:mm:ssZ',
            ),
        };
        const clockOutPostData = {
            ...postDate,
            category: 'CO',
            clocking_time: this.state.adminClockOutTime.format(
                'YYYY-MM-DDTHH:mm:ssZ',
            ),
        };
        const canClockIn =
            (this.state.clockin && this.state.clockin.pending) ||
            !this.state.clockin;
        const canClockOut =
            (this.state.clockout && this.state.clockout.pending) ||
            (!this.state.clockout && this.state.passedClockOutTime);

        if (this.props.isClient && canClockOut) {
            this.postTime(clockOutPostData).then(() => {
                this.clockInOutUpdated(
                    `Updated clock-out time for ${self.props.job.booking.freelancer_detail.full_name}`,
                );
            });
        } else if (canClockIn && canClockOut) {
            let response;

            // eslint-disable-next-line prefer-const
            response = this.postTime(clockInPostData);
            response.then(() => {
                self.postTime(clockOutPostData)
                    .then(() => {
                        self.clockInOutUpdated(
                            `${self.props.job.booking.freelancer_detail.full_name} has been successfully clocked-in & out`,
                        );
                    })
                    .catch(() => {
                        self.clockInOutUpdated(
                            `${self.props.job.booking.freelancer_detail.full_name} could not be clocked-out`,
                            false,
                        );
                    });
            });
        } else if (canClockIn) {
            this.postTime(clockInPostData)
                .then(() => {
                    self.clockInOutUpdated(
                        `${self.props.job.booking.freelancer_detail.full_name} has been successfully clocked-in`,
                    );
                })
                .catch(() => {
                    self.clockInOutUpdated(
                        `${self.props.job.booking.freelancer_detail.full_name} could not be clocked-in`,
                        false,
                    );
                });
        } else if (canClockOut) {
            this.postTime(clockOutPostData)
                .then(() => {
                    self.clockInOutUpdated(
                        `${self.props.job.booking.freelancer_detail.full_name} has been successfully clocked-out`,
                    );
                })
                .catch(() => {
                    self.clockInOutUpdated(
                        `${self.props.job.booking.freelancer_detail.full_name} could not be clocked-out`,
                        false,
                    );
                });
        } else if (this.props.mode === 'payroll') {
            this.props.reloadData();
        } else {
            this.closeModal(true);
        }
    }

    getConflictReasonText() {
        let conflictReason = '';
        if (
            !this.state.clockin &&
            !this.state.clockout &&
            this.state.passedClockOutTime
        ) {
            conflictReason = 'The worker did not clock in and out.';
        } else if (!this.state.clockin) {
            conflictReason = 'The worker did not clock-in.';
        } else if (!this.state.clockout && this.state.passedClockOutTime) {
            conflictReason = 'The worker did not clock-out.';
        } else {
            if (this.state.clockin && this.state.clockin.pending) {
                conflictReason +=
                    ' The worker was not at the location when clocking-in.';
            }
            if (this.state.clockout && this.state.clockout.pending) {
                conflictReason += ' The worker clocked-out late.';
            }
        }
        return conflictReason;
    }

    getClockInAdminOveride() {
        return this.state.clockin && !this.state.clockin.pending ? (
            'Clock-in already settled'
        ) : (
            <DatePicker
                selected={new Date(this.state.adminClockInTime)}
                onChange={this.handleAdminClockInDateTimeChange}
                includeDates={[
                    moment(this.props.job.start_datetime),
                    moment(this.props.job.start_datetime).add(1, 'days'),
                ]}
                showTimeSelect={true}
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="dd/MM HH:mm"
            />
        );
    }

    getClockOutAdminOveride() {
        // eslint-disable-next-line no-nested-ternary
        return this.state.clockout && !this.state.clockout.pending ? (
            'Clock-out already settled'
        ) : !this.state.clockout && !this.state.passedClockOutTime ? (
            'Booking on going'
        ) : (
            <DatePicker
                selected={new Date(this.state.adminClockOutTime)}
                onChange={this.handleAdminClockOutDateTimeChange}
                includeDates={[
                    moment(this.props.job.end_datetime),
                    moment(this.props.job.end_datetime).add(1, 'days'),
                ]}
                showTimeSelect={true}
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="dd/MM HH:mm"
            />
        );
    }

    renderContentForClient() {
        return (
            <div className="modal-dialog">
                <div className="modal-header">
                    <h4>
                        Clock-out confirmation for{' '}
                        {this.props.job.booking.freelancer_detail.full_name}
                    </h4>
                    <a
                        href="#"
                        className="btn-close"
                        onClick={() => this.closeModal(false)}
                    >
                        ×
                    </a>
                </div>
                <div className="modal-body">
                    <div className="conflict-times-sec">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th />
                                    <th>Planned</th>
                                    <th>
                                        {
                                            this.props.job.booking
                                                .freelancer_detail.full_name
                                        }
                                    </th>
                                    <th>Final value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="font-bold-800">Clock-out</td>
                                    <td>
                                        {moment(
                                            this.props.job.end_datetime,
                                        ).format('DD/MM HH:mm')}
                                    </td>
                                    {this.state.clockout ? (
                                        <td>
                                            {moment(
                                                this.state.clockout
                                                    .clocking_time,
                                            ).format('DD/MM HH:mm')}
                                        </td>
                                    ) : (
                                        <td>Not clocked-out</td>
                                    )}
                                    <td>{this.getClockOutAdminOveride()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div />
                </div>
                <div className="actions">
                    {this.state.isPosting ? (
                        <div className="text-align-center">
                            <Loader color="gray" size="20px" margin="20px" />
                        </div>
                    ) : (
                        <button
                            className="confirm-btn"
                            type="button"
                            onClick={() => this.updateClockInOutTimes()}
                        >
                            Confirm
                        </button>
                    )}
                </div>
            </div>
        );
    }

    renderContentForAgent() {
        return (
            <div className="modal-dialog">
                <div className="popup-header">
                    <div
                        className="popup-header-dismiss"
                        onClick={() => this.closeModal(false)}
                    >
                        <i className="icon icon-close" />
                    </div>
                    <h1>Booking settlement</h1>
                    <h2>{this.getConflictReasonText()}</h2>
                </div>
                <div className="modal-body">
                    {!this.props.isClient ? (
                        <ClockInOutMapComponent
                            googleMapURL={googleMapsURL}
                            loadingElement={<div style={{ height: '100%' }} />}
                            containerElement={
                                <div style={{ height: '300px' }} />
                            }
                            mapElement={<div style={{ height: '100%' }} />}
                            onMapMounted={this.onMapMounted}
                            job={this.props.job}
                            clockin={this.state.clockin}
                            clockout={this.state.clockout}
                        />
                    ) : null}

                    <div className="conflict-times-sec">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th />
                                    <th>Planned</th>
                                    <th>
                                        {
                                            this.props.job.booking
                                                .freelancer_detail.full_name
                                        }
                                    </th>
                                    <th>Final value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="font-bold-800">Clock-in</td>
                                    <td>
                                        {moment(
                                            this.props.job.start_datetime,
                                        ).format('DD/MM HH:mm')}
                                    </td>
                                    {this.state.clockin ? (
                                        <td>
                                            {moment(
                                                this.state.clockin
                                                    .clocking_time,
                                            ).format('DD/MM HH:mm')}
                                        </td>
                                    ) : (
                                        <td>Not clocked-in</td>
                                    )}
                                    <td>{this.getClockInAdminOveride()}</td>
                                </tr>
                                <tr>
                                    <td className="font-bold-800">Clock-out</td>
                                    <td>
                                        {moment(
                                            this.props.job.end_datetime,
                                        ).format('DD/MM HH:mm')}
                                    </td>
                                    {this.state.clockout ? (
                                        <td>
                                            {moment(
                                                this.state.clockout
                                                    .clocking_time,
                                            ).format('DD/MM HH:mm')}
                                        </td>
                                    ) : (
                                        <td>Not clocked-out</td>
                                    )}
                                    <td>{this.getClockOutAdminOveride()}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div />
                </div>
                <div className="modal-bottom-bar">
                    {this.state.isPosting ? (
                        <div className="text-align-center">
                            <Loader color="gray" size="20px" margin="20px" />
                        </div>
                    ) : (
                        <button
                            className="table-action-button"
                            type="button"
                            onClick={() => this.updateClockInOutTimes()}
                        >
                            Settle Booking
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="booking-conflict-times-container">
                {(() => {
                    if (this.props.isClient) {
                        return this.renderContentForClient();
                    }
                    return this.renderContentForAgent();
                })()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps)(ConflictTimesContainer);
